<template>
  <div>
    <div v-show="!showApproveForm">
      <slot></slot>
      <center>
        <center class='grey-text' style="font-size: 1.5em">
          Add a tip
        </center>
        <section class='mt-10 grey-text' v-if='showTips && !tipsLoading'>
          <div class='tips-row' v-show="presetTip">
            <div class='tips-btn tips-col' :class="{'active': selectedTip == 0}" @click='setTip(0)'>No tip</div>
            <div class='tips-btn tips-col' :class="{'active': selectedTip == tip1}" @click='setTip(tip1)'>{{tip1}}%</div>
            <div class='tips-btn tips-col' :class="{'active': selectedTip == tip2}" @click='setTip(tip2)'>{{tip2}}%</div>
            <div class='tips-btn tips-col' :class="{'active': selectedTip == tip3}" @click='setTip(tip3)'>{{tip3}}%</div>
          </div>

          <div v-if='!presetTip'>
            <input 

                name='tipCustomAmount'
                ref="customTipInput"
                step="0.01"
                type="number"
                pattern="\d*"
                v-validate="'min_value:0.01|required'"
                class='inputText'
                lang="en-001"
                v-model='tipCustomAmount'
                @keyup="updateAmounts">

                <span class='red-text small-font' v-show='errors.first("tipCustomAmount")'>Must be 0.01 or more.</span>
          </div>
          <div class='tips-row mt-5'>
            <div class='btn tips-col' @click='enableCustomTip'>{{tipSwitchLabel}}</div>
          </div>
        </section>
        <div class='card-panel mt-10'>
          <section v-show="!errorMessage">
            <center class='grey-text' style="font-size: 1.8em">
              Please sign here:
            </center>

            <vue-signature-pad width="100%" 
                               height="27vh"
                               :options="{ onBegin }"
                               ref="signaturePad" />
            <span class='grey-text'>
              X __________________________<br>
              <small>I authorize to debit my account an extra {{tipAmount | currency}} as a tip</small>
            </span>
          </section>
        </div>

        <div class='red-text center' v-show='errorMessage'>
          {{errorMessage}}<br>
        </div>

        <div class='mt-5'>  
          <span class='btn-flat mt-5' v-show='!errorMessage' @click='undo'>Clear</span>
          <span class='btn mt-5' @click='approve' v-show='showSubmit && selectedTip == 0' :disabled='disableSubmit'>Approve {{withTipAmount}}</span>
          <span class='btn mt-5' @click='showApproveForm = true' v-show='showSubmit && selectedTip != 0' :disabled='disableSubmit'>Continue</span><br>
          <div class="mt-5 grey-text">
            By clicking "Approve" you agree to <a href="https://iwallet.com/terms-of-service">terms of service</a> 
            as well as our partner Paya's <a href="/paya_ach_terms" ctarget="_blank">ACH debit term and conditions</a>
          </div>
        </div>

        <div v-show='!showSubmit'>
          <i class="fas fa-spinner fa-spin"></i> 
          processing ...
        </div>
      </center>
    </div>
    <div v-show="showApproveForm" class="mt-50">
       I, <br>
       <div>
         <label>First name</label>
         <input name="fname" v-validate="'required'" v-model="firstName"/>
         <span class='red-text small-font' v-show='errors.first("fname")'>The first name field is required</span>
       </div>
       <div>
         <label>Last name</label>
         <input name="lname" v-validate="'required'" v-model="lastName"/>
         <span class='red-text small-font' v-show='errors.first("lname")'>The last name field is required</span>
       </div>
       <br>
       <div class="mt-25">
         <slot name="auth-details"></slot>
       </div>
       <div class="mt-25 bold-font large-font">
         authorize one-time payment of {{tipAmount | currency}} on today's date {{$moment(new Date()).format('MM/DD/YY')}} and accept 
         <a @click="showTerms=true">ACH debit terms and conditions</a>
       </div>
       <div v-show="showTerms">
          <ul>
            <li class="mt-25">
              When you provide a check as payment you authorize us to
              either use information from your check to make a one-time
              electronic fund transfer from your account or to process the
              payment as a check transaction.</li>
            <li class="mt-25">
              When we use information from your check to make an
              electronic funds transfer, funds may be withdrawn from your
              account as soon as the same day you make your payment. 
            </li>
            <li class="mt-25">
              A returned check fee of $25.00, or maximum allowable by law,
              will be electronically debited from your account in the event
              your electronic transfer is returned from your financial
              institution. 
            </li>
          </ul>
       </div>
       <div class="mt-50">
         <button class="btn btn-large wide-btn" @click="approve">Accept</button>
         <button class="btn outlined-btn wide-btn mt-25" @click="showApproveForm=false">Cancel</button>
       </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ["transactionToken", "amount", "qid", "showTips"],
    data() {
      return {
        disableSubmit: true,
        showSubmit: true,
        selectedTip: 0,
        feeAmount: 0,
        withTipAmount: 0,
        tipAmount: 0,
        tipCustomAmount: 0,
        errorMessage: null,
        tipsLoading: true,
        tip1: 0,
        tip2: 0,
        tip3: 0,
        selectedTip: 0,
        presetTip: true,
        showApproveForm: false,
        firstName: null,
        lastName: null,
        showTerms: false
      }
    },
    created() {
      if(this.showTips) {
        this.loadTips()
      } else {
        this.updateAmounts()
      }
    },
    methods: {
      onBegin() {
        this.disableSubmit = false
      },
      undo() {
       this.showBottons = false
       this.$refs.signaturePad.undoSignature()
      },
      approve() {
        this.$validator.validateAll().then((result) => {
          console.log("Result:", result)
          if (result || this.selectedTip == 0) {
            this.disableSubmit = true
            this.showSubmit = false
            const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
            if(isEmpty) {
              this.notifyError("Empty Signature!")
              this.disableSubmit = false
              this.showSubmit = true
            } else {
              if(this.selectedTip == 0 && (this.tipCustomAmount == 0 || this.tipCustomAmount == null)) {
                Turbolinks.visit('/c21/thank_you?amount=' + this.withTipAmount)
              } else {
                this.$http.post('/c21/' + this.transactionToken + '/approve', {tip_percent: this.selectedTip, tip_custom_amount: this.tipCustomAmount, signature_image: data, first_name: this.firstName, last_name: this.lastName}).then(response => {
                  Turbolinks.visit('/c21/thank_you?gid=' + response.body.transaction_gid)
                }, error => {

                  this.disableSubmit = false
                  this.showSubmit = true
                  this.errorHandler(error)
                })
              }
            }
          } else {
            console.log("Not boom )))")
          }
        })
      },
      loadTips() {
        this.$http.get("/api/v1/vue/tip_values", {params: {qid: this.qid}}).then(response => {
          this.tip1 = response.body.tip1
          this.tip2 = response.body.tip2
          this.tip3 = response.body.tip3
          this.selectedTip = 0
          this.tipsLoading = false
          this.updateAmounts()
        }, error => {
          // Fallback to defualt tips
          this.tip1 = 15
          this.tip2 = 20
          this.tip3 = 25
          this.selectedTip = 0
          this.tipsLoading = false
          this.updateAmounts()
        })
      },
      setTip(tip) {
        this.selectedTip = tip
        this.updateAmounts()
      },
      updateAmounts() {
        this.$http.get("/api/v1/vue/gross_check_calculations", {params: this.params}).then(response => {
          this.feeAmount = response.body.fee
          this.withTipAmount = response.body.amount_with_tip
          this.tipAmount = response.body.tip_amount
        })
      },
      enableCustomTip() {
        this.selectedTip = 0
        this.tipCustomAmount = null
        this.presetTip = !this.presetTip
        this.updateAmounts()
        if(!this.presetTip) {
          this.$nextTick(() => {
            this.$refs.customTipInput.focus()
          })
        }
      }
    },
    computed: {
      params() {
        return {
          amount: this.amount,
          tip_percent: this.selectedTip,
          tip_custom_amount: this.tipCustomAmount,
          qid: this.qid
        }
      },
      tipSwitchLabel() {
        return this.presetTip ? "Custom tip" : "Go back"
      }
    }
  }
</script>
<style scoped>
  .active {
    background-color: #fff;
    border: 2px solid  #00ab8e;
    color: #00ab8e;
  }
</style>
